export default {
  LIST_FETCHED: 'AUTOMATIONS_FETCHED',
  LIST_LOAD: 'AUTOMATIONS_LOAD',
  ITEM_DETAIL: 'AUTOMATIONS_DETAIL',
  BUTTON_LOAD: 'AUTOMATIONS_BUTTON_LOAD',
};
